/**
 * Inserts link element with given href to document head if not present already
 * @param href
 */
function loadStyles(href) {
  const existing = document.querySelectorAll(`link[href='${href}']`);
  if (existing.length === 0) {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}

export default loadStyles;
